export default __webpack_public_path__ + "static/media/video-small.6b1ff7ba.svg";